(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/start-subscription/assets/javascripts/models/startentry.js') >= 0) return;  svs.modules.push('/components/tur/start-subscription/assets/javascripts/models/startentry.js');
"use strict";


(function (Backbone, _, svs) {
  'use strict';

  svs.tur.start_subscription.models.StartEntry = svs.tur.start_subscription.models.Entry.extend({
    CONSTANTS: svs.tur.start_subscription.constants,
    defaults() {
      return _.extend(typeof this.constructor.__super__.defaults === 'function' ? this.constructor.__super__.defaults() : this.constructor.__super__.defaults, {
        subscriptionEntry: {},
        subscriptionOptions: {},
        cardEntry: undefined,
        autogiroEntry: undefined,
        communicationType: undefined,
        isPaymentTypeChanged: undefined,
        isNewSubOnlyBankcardFirstTime: undefined
      });
    },
    initialize() {
      this.listenTo(this, 'change:entry', function (model, entry) {
        this.set(this.parseSelectedEntry(model, entry));
      });
    },
    checkIfNewSubOnlyBankcard(entries) {
      if (this.get('isNewSubOnlyBankcard')) {
        var _entries$entryInfo$fi, _entries$entryInfo$fi2;
        const isChangeable = entries.paymentTypeChangePossible;
        const isPaymentTypeSet = Boolean(this.CONSTANTS.PAYMENT_TYPE[entries.paymentType]);
        const isAutogiroPayChannelActive = (_entries$entryInfo$fi = entries.entryInfo.find(entry => entry.paymentType === this.CONSTANTS.PAYMENT_TYPE.AUTOGIRO.TYPE)) === null || _entries$entryInfo$fi === void 0 ? void 0 : _entries$entryInfo$fi.payChannelActive;
        const isBankcardPayChannelActive = (_entries$entryInfo$fi2 = entries.entryInfo.find(entry => entry.paymentType === this.CONSTANTS.PAYMENT_TYPE.BANK_CARD.TYPE)) === null || _entries$entryInfo$fi2 === void 0 ? void 0 : _entries$entryInfo$fi2.payChannelActive;
        const isNoPayChannelActive = !isAutogiroPayChannelActive && !isBankcardPayChannelActive;

        return Boolean(isChangeable && (!isPaymentTypeSet || isNoPayChannelActive) || isPaymentTypeSet && !isAutogiroPayChannelActive);
      }
      return false;
    },
    parseSelectedEntry(model, entry) {
      const entryData = {};
      if (entry) {
        if (this.has('paymentType') && this.get('paymentType') !== entry.paymentType) {
          entryData.isPaymentTypeChanged = true;
        }
        entryData.amount = entry.amount;
        entryData.startTime = entry.startTime;
        entryData.stopTime = entry.stopTime;
        entryData.hasActivePayChannel = entry.payChannelActive;
        entryData.hasChangeablePayChannel = model.get('hasChangeablePayChannel');
        entryData.paymentType = entry.paymentType;
        entryData.paymentTypeText = this.CONSTANTS.PAYMENT_TYPE[entry.paymentType].TEXT;
        entryData.isAutogiro = this.CONSTANTS.PAYMENT_TYPE.AUTOGIRO.TYPE === entry.paymentType;
        entryData.isBankcard = this.CONSTANTS.PAYMENT_TYPE.BANK_CARD.TYPE === entry.paymentType;
        entryData.weeklyCost = model.get('subscriptionOptions').weeklyCost;
      }
      return entryData;
    },
    parseEntryOrAnnouncement(data) {
      const self = this;
      const entryData = {};
      delete data.requestId;
      delete data.requestInfo;
      entryData.communicationType = data.communicationType;
      entryData.hasChangeablePayChannel = data.paymentTypeChangePossible;

      if (this.CONSTANTS.PAYMENT_TYPE[data.paymentType]) {
        entryData.paymentType = data.paymentType;
      }
      if (data.entryInfo.length < 2) {
        entryData.entry = data.entryInfo[0];
      } else if (this.checkIfNewSubOnlyBankcard(data)) {
        entryData.entry = _.find(data.entryInfo, entry => entry.paymentType === self.CONSTANTS.PAYMENT_TYPE.BANK_CARD.TYPE);

        entryData.isNewSubOnlyBankcardFirstTime = true;

        if (entryData.paymentType === self.CONSTANTS.PAYMENT_TYPE.AUTOGIRO.TYPE) {
          entryData.isPaymentTypeChanged = true;
        }
      } else {
        entryData.cardEntry = _.find(data.entryInfo, entry => entry.paymentType === self.CONSTANTS.PAYMENT_TYPE.BANK_CARD.TYPE);
        entryData.autogiroEntry = _.find(data.entryInfo, entry => entry.paymentType === self.CONSTANTS.PAYMENT_TYPE.AUTOGIRO.TYPE);
        entryData.cardEntry.isBankcard = true;
        entryData.autogiroEntry.isAutogiro = true;
      }
      return entryData;
    },
    parseNewSubscription(data) {
      delete data.requestId;
      delete data.requestInfo;
      return {
        newSubId: data.subscriptionId
      };
    },
    getEntryOrAnnouncement(options) {
      options = options || {};

      const model = this;
      const context = options.context;
      const successCallback = options.success;

      options.success = function (response) {
        const attr = model.parseEntryOrAnnouncement(response);
        model.set(attr);
        svs.components.loader.hide();
        successCallback && successCallback.call(context, model, response, options);
      };
      options.error = model.parseError;

      options.url = "".concat(svs.core.jupiter.url(), "/subscription/2/subscriptionentry");
      options.attrs = this.get('subscriptionEntry');
      svs.components.loader.show();
      this.sync('create', this, options);
    },
    postNewSubscription(options) {
      options = options || {};

      const model = this;
      const context = options.context;
      const successCallback = options.success;

      options.success = function (response) {
        const attr = model.parseNewSubscription(response);
        model.set(attr);

        const storageModel = {
          newSubId: model.get('newSubId'),
          dayCost: svs.utils.format.Currency(parseInt(model.get('subscriptionEntry').wagers[0].wagerAmount, 10)),
          isBankcard: model.get('isBankcard'),
          amount: svs.utils.format.Currency(model.get('entry').amount),
          weeklyCost: svs.utils.format.Currency(model.get('weeklyCost')),
          startTime: svs.utils.date.FormatTime('d MMM', model.get('entry').startTime).replace('.', ''),
          stopTime: svs.utils.date.FormatTime('d MMM', model.get('entry').stopTime).replace('.', ''),
          gameDaysStart: parseInt(model.get('entry').amount, 10) / parseInt(model.get('subscriptionEntry').wagers[0].wagerAmount, 10),
          gameResultDate: svs.utils.format.capitalize(svs.utils.date.FormatTime('EEEE d MMM', model.get('entry').startTime).replace('.', '')),
          lottoRuleChangePrice: svs.utils.format.Currency(model.get('subscriptionOptions').lottoRuleChangePrice),
          lottoRuleChangeDate: model.get('subscriptionOptions').lottoRuleChangeDate
        };
        svs.components.Storage.browser.set('templateObject', 'start_subscription', storageModel, svs.components.Storage.constants.EXPIRES_15M);
        svs.components.loader.hide();
        successCallback && successCallback.call(context, model, response, options);
      };
      options.error = function (error) {
        model.clear({
          silent: true
        });
        model.parseError(error);
      };

      options.url = "".concat(svs.core.jupiter.url(), "/subscription/3/definesubscription");
      options.attrs = this.get('subscriptionEntry');
      options.attrs.paymentType = this.get('paymentType');
      options.attrs.entryInfo = this.get('entry');
      svs.components.loader.show();
      this.sync('create', this, options);
    }
  });
})(Backbone, _, svs);

 })(window);